import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { translationRequest } from '../requests';

export const useTranslation = (
  { type, id, attribute, text, lang },
  { staleTime = ms('1h'), enabled = true } = {},
) => {
  const { data = {}, ...rest } = useQuery({
    queryKey: ['translations', 'translate', type, id, text, attribute, lang],
    queryFn: () => translationRequest({ type, id, attribute, text, lang }),
    staleTime,
    retry: false,
    enabled,
  });

  return {
    ...data,
    ...rest,
  };
};
